import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Hamburger from "../images/menuIcon.png";
import "../styles/navBar.css";
const NavBar = () => {
  const [showNavbar, setShowNavbar] = useState(false);

  const toggleNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <nav className="navBar">
      <div className="leftNavBar">
        <img src="/HiALogo.png" alt="Healthcare interAction Logo" />
      </div>
      <div className="menu-icon" onClick={toggleNavbar}>
        <img src={Hamburger} alt="Menu Icon" />
      </div>
      <div className={`rightNavBar ${showNavbar && "active"}`}>
        <ul className="navLinks" onClick={toggleNavbar}>
          <li>
            <NavLink to="/" onClick={scrollToTop}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/aboutUs" onClick={scrollToTop}>
              About Us
            </NavLink>
          </li>
          <li>
            <NavLink to="/howWeCanHelp" onClick={scrollToTop}>
              Transform Your Teams
            </NavLink>
          </li>
          <li>
            <NavLink to="/articles" onClick={scrollToTop}>
              Coffee Break Articles
            </NavLink>
          </li>
          <li>
            <NavLink to="/sustainability" onClick={scrollToTop}>
              Sustainability
            </NavLink>
          </li>
          <li>
            <NavLink to="/team" onClick={scrollToTop}>
              Our Team
            </NavLink>
          </li>
          <li className="contact">
            <NavLink to="/contact" onClick={scrollToTop}>
              Contact Us
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};
export default NavBar;
